//React
import React from 'react';
import { Routes, Route, Navigate} from 'react-router-dom';
//CSS
import './App.css';
//FIREBASE
import { getAuth, verifyPasswordResetCode, confirmPasswordReset, applyActionCode  } from "firebase/auth";
import { useAuthState } from 'react-firebase-hooks/auth';
import { GetParameterByName } from './helpers/URLHelper';

import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";
//Components (reusable components)
import { app, analytics } from './components/Firebase';
import Navbar from './components/Navbar';
//Pages (single-use components)

import Home from './pages/Home';
import Signup from './pages/Signup';
import Signin from './pages/Signin';
import ForgotPsw from './pages/ForgotPsw';
import About from './pages/About';
import Legal from './pages/Legal';
import Contact from './pages/Contact';
import RequestSurveys from './pages/RequestSurveys';
import SurveyStatus from './pages/SurveyStatus';
import Product from './pages/Product';
import Account from './pages/Account'
import Survey from './pages/Survey';


  // Create a ReCaptchaEnterpriseProvider instance using your reCAPTCHA Enterprise
  // site key and pass it to initializeAppCheck().
  const appCheck = initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(process.env.REACT_APP_RECAPTCHA_SITE_KEY),
    isTokenAutoRefreshEnabled: true // Set to true to allow auto-refresh.
  });

  // Initialize Firebase Authentication and get a reference to the service
  const auth = getAuth(app);

function handleResetPassword(auth, actionCode, continueUrl, lang) {
  // Localize the UI to the selected language as determined by the lang
  // parameter.

  // Verify the password reset code is valid.
  verifyPasswordResetCode(auth, actionCode).then((email) => {
    const accountEmail = email;

    // TODO: Show the reset screen with the user's email and ask the user for
    // the new password.
    const newPassword = "...";

    // Save the new password.
    confirmPasswordReset(auth, actionCode, newPassword).then((resp) => {
      // Password reset has been confirmed and new password updated.

      // TODO: Display a link back to the app, or sign-in the user directly
      // if the page belongs to the same domain as the app:
      // auth.signInWithEmailAndPassword(accountEmail, newPassword);

      // TODO: If a continue URL is available, display a button which on
      // click redirects the user back to the app via continueUrl with
      // additional state determined from that URL's parameters.
    }).catch((error) => {
      // Error occurred during confirmation. The code might have expired or the
      // password is too weak.
    });
  }).catch((error) => {
    // Invalid or expired action code. Ask user to try to reset the password
    // again.
  });
}

function handleVerifyEmail(auth, actionCode, continueUrl, lang) {
  // Localize the UI to the selected language as determined by the lang
  // parameter.
  // Try to apply the email verification code.
  applyActionCode(auth, actionCode).then((resp) => {
    // Email address has been verified.
    return App();
    // TODO: Display a confirmation message to the user.
    // You could also provide the user with a link back to the app.
    // TODO: If a continue URL is available, display a button which on
    // click redirects the user back to the app via continueUrl with
    // additional state determined from that URL's parameters.
  }).catch((error) => {
    // Code is invalid or expired. Ask the user to verify their email address
    // again.
  });
}

function PrivateRoute(props) {
  const {user, loading, error, children} = props;
  if (error) {
    console.log("Error: ", error);
  }
  if (loading) {
    return <div>Loading...</div>;
  }
  return (user && auth.currentUser.emailVerified) ? children : <Navigate to="/signin" replace />;
}


const Main = ({ user, loading, error }) => {
  
  document.addEventListener('DOMContentLoaded', () => {
    // TODO: Implement getParameterByName()

    // Get the action to complete.
    const mode = GetParameterByName('mode');
    // Get the one-time code from the query parameter.
    const actionCode = GetParameterByName('oobCode');
    // (Optional) Get the continue URL from the query parameter if available.
    const continueUrl = GetParameterByName('continueUrl');
    // (Optional) Get the language code if available.
    const lang = GetParameterByName('lang') || 'en';
  
    // Handle the user management action.
    switch (mode) {
      case 'resetPassword':
        // Display reset password handler and UI.
        handleResetPassword(auth, actionCode, continueUrl, lang);
        break;
      case 'verifyEmail':
        // Display email verification handler and UI.
        handleVerifyEmail(auth, actionCode, continueUrl, lang);
        break;
      default:
        // Error: invalid mode.
    }
  }, false);
  return (
<Routes>
  <Route path='/' element={<Home user={user}/>}/>
  <Route path='/signup' element={<Signup />}/>
  <Route path='/signin' element={<Signin />}/>
  <Route path='/forgotpsw' element={<ForgotPsw />}/>
  <Route path="/about" element={<About />} />
  <Route path="/legal" element={<Legal />} />
  <Route path="/contact" element={<Contact />} />
  <Route path="/requestsurveys" element={<PrivateRoute user={user} loading={loading} error={error}><RequestSurveys /></PrivateRoute>} />
  <Route path="/surveystatus" element={<PrivateRoute user={user} loading={loading} error={error}><SurveyStatus /></PrivateRoute>} />
  <Route path="/product" element={<Product />} />
  <Route path="/account" element={<PrivateRoute user={user} loading={loading} error={error}><Account /></PrivateRoute>} />
  <Route path="/survey" element={<Survey />} />
</Routes>
  );
}

//Wrap your app’s top-level component with BrowserRouter to enable routing in your app
//Use the Route component to define your app’s routes and render the appropriate components based on the current URL
function App() {
  const [user, loading, error] = useAuthState(auth);
  return (
    <div className="App">
      {window.location.pathname !== "/survey" && <Navbar />}
      <Main user={user} loading={loading} error={error} />
    </div>
  );
}
export { appCheck };
export default App;
